import React from "react";
import PropTypes from "prop-types";
import { Spinner } from "react-bootstrap";

export default function TextLoading(props) {
  return (
    <span className="d-flex justify-content-center align-items-center">
      {props.text}...
      <Spinner
        as="span"
        animation="border"
        role="status"
        aria-hidden="true"
        variant={props.variant}
        style={{
          width: "0.81rem",
          height: "0.81rem",
          marginLeft: "3px",
          borderWidth: "0.17em",
          verticalAlign: "middle",
        }}
      />
    </span>
  );
}

TextLoading.propTypes = {
  text: PropTypes.string,
  variant: PropTypes.string,
};
